import { render, staticRenderFns } from "./Page-Location.vue?vue&type=template&id=04728c60&"
import script from "./Page-Location.vue?vue&type=script&lang=js&"
export * from "./Page-Location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports